export default function HowItWorks() {
  const steps = [
    {
      num: "01",
      title: "Browse Mulebuy Spreadsheet Listings",
      desc: "Access the comprehensive Mulebuy spreadsheet catalog organized by 14 distinct product categories. Each listing provides essential product details and pricing information in a clear, scannable format.",
    },
    {
      num: "02",
      title: "Compare Products and Pricing",
      desc: "Use the Mulebuy spreadsheet system to compare items side by side. The structured spreadsheet format makes it easy to identify the best deals and make informed purchasing decisions quickly.",
    },
    {
      num: "03",
      title: "Select Items Through Spreadsheet Links",
      desc: "Once you have found the products you want, simply follow the direct links from the Mulebuy spreadsheet to access the full product pages with detailed descriptions and images.",
    },
    {
      num: "04",
      title: "Redirect to Purchasing System",
      desc: "Each Mulebuy spreadsheet link takes you to the main platform where you can complete your purchase securely. The spreadsheet serves as your organized starting point.",
    },
    {
      num: "05",
      title: "Track Orders in Spreadsheet Format",
      desc: "Many experienced Mulebuy spreadsheet users maintain their own tracking sheets to monitor orders, compare prices over time, and build their personal shopping databases.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
          How the Mulebuy Spreadsheet System Works
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-xl">
          A simple step-by-step breakdown of how shoppers use the spreadsheet shopping method to find and purchase products efficiently.
        </p>

        <div className="mt-10 space-y-6">
          {steps.map((step) => (
            <div key={step.num} className="flex gap-5 md:gap-8 items-start p-6 bg-background-50 rounded-lg">
              <span className="font-heading text-3xl md:text-4xl font-bold text-accent-500 shrink-0 w-16 md:w-20">
                {step.num}
              </span>
              <div>
                <h3 className="font-semibold text-foreground-950 text-base md:text-lg">{step.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}